import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  TextContainer,
  Toast,
  Checkbox,
  FormLayout,
  ChoiceList,
  Filters,
  TextField,
  Badge,
  Tabs,
  Thumbnail,
  DropZone,
  InlineStack,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { countryList } from "../Assets/Countries.js";
import { accessSettings } from "../Helpers";
import LoadingScreen from "../Components/LoadingScreen";

const Templates = () => {
  const [item, setItem] = useState({
    name: "",
    description: "",
    image: "",
  });
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const addEditState = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleAddTemplate = () => {
    addEditState.current = "add-template";
    setFile();
    setItem({ ...item, name: "", description: "" });

    setImage("");
    setActiveAddEdit(true);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Name", value: "name" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [selected, setSelected] = useState(0);
  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "rich_text",
      content: "Rich Text",
    },
    {
      id: "banner",
      content: "Banner",
    },
    {
      id: "image",
      content: "Image with Text",
    },
    {
      id: "list",
      content: "List",
    },
    {
      id: "video",
      content: "Video",
    },
    {
      id: "object",
      content: "Object",
    },
    {
      id: "custom_block",
      content: "Custom Block",
    },
    {
      id: "shopify_collection",
      content: "Shopify Collection",
    },
    {
      id: "shopify_products_list",
      content: "List of Shopify Products",
    },
  ];
  useEffect(() => {
    setIsLoading(true);
    setIsListEmpty(false);
    setItems([]);
    getData();
  }, [ts, availability, queryValue, selected]);
  const getData = () => {
    axios
      .get(
        `/section-templates${
          queryValue
            ? `?filter[${
                availability === "" ? "description" : availability
              }]=${queryValue}&filter[section_type]=${tabs[selected].id}`
            : `?filter[section_type]=${tabs[selected].id}`
        }`
      )
      .then((result) => {
        !result.data.data.data.length
          ? setIsListEmpty(true)
          : setIsListEmpty(false);
        setItems(
          result.data.data.data.map((item, index) => [
            <div className="row_click2">
              {item.image ? (
                <Thumbnail size="small" source={item.image}></Thumbnail>
              ) : (
                ""
              )}
            </div>,
            <div className="row_click2">
              {item.description ? item.description : ""}
            </div>,
            <div className="me-3">
              <ButtonGroup>
                <Button onClick={() => handleEdit(item)}>Edit</Button>
                <Button destructive onClick={() => handleDelete(item.id)}>
                  Delete
                </Button>
              </ButtonGroup>
            </div>,
          ])
        );
        setIsLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
        }
      });
  };
  const [checkedIsDefault, setCheckedIsDefault] = useState(false);
  const handleChangeIsDefault = (newValue) => {
    setCheckedIsDefault(newValue);
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This template has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const clickedTemplate = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    clickedTemplate.current = id;
    setActiveDelete(true);
  };
  const handleEdit = (item) => {
    addEditState.current = "edit-template";
    clickedTemplate.current = item;

    setItem({
      ...item,
      name: item.description ? item.description : "",
      description: item.text ? item.text : "",
      image: item.image ? item.image : "",
    });

    setActiveAddEdit(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/section-templates/${clickedTemplate.current}`)
      .then((result) => {
        setToastContent("This template has been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const [templateNameValue, setTemplateNameValue] = useState("");
  const handleChangeTemplateName = (value) => {
    setItem({ ...item, name: value });
    setTemplateNameError("");
  };
  const [templateDescriptionValue, setTemplateDescriptionValue] = useState("");
  const handleChangeTemplateDescription = (value) => {
    setItem({ ...item, description: value });
  };
  const [templateSlugValue, setTemplateSlugValue] = useState("");
  const handleChangeSlugName = (value) => {};
  const [templateNameError, setTemplateNameError] = useState("");
  const [activeAddEdit, setActiveAddEdit] = useState(false);
  const handleChangeModalAddEdit = useCallback((activeAddEdit) => {
    setFile();

    setActiveAddEdit(!activeAddEdit);
    setIsSaving(false);
  }, []);
  const handleSubmitAddEdit = () => {
    console.log("test=", item.description);
    if (!item.name) {
      setTemplateNameError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("description", item.name);
      form_data.append("text", item.description);
      imageKey.current && form_data.append("image", imageKey.current);
      form_data.append("section_type", tabs[selected].id);
      addEditState.current === "edit-template" &&
        form_data.append("_method", "PATCH");
      let url =
        addEditState.current === "add-template"
          ? `/section-templates`
          : `/section-templates/${clickedTemplate.current.id}`;
      axios
        .post(url, form_data)
        .then((result) => {
          setToastContent(
            addEditState.current === "add-template"
              ? `This template has been successfully added`
              : "Changes have been saved successfully"
          );
          toggleActive();
          setIsSaving(false);
          setActiveAddEdit(false);
          setTs(+new Date());
        })
        .catch((err) => console.log(err));
    }
  };

  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );
  const [image, setImage] = useState("");
  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section_template");
    form_data.append("image", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });

        // setItem({
        //   ...item,
        //   logo:
        // validImageTypes.indexOf(file[file.length - 1].type) > 0
        //   ? window.URL.createObjectURL(file[file.length - 1])
        //   : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        // });
      })
      .catch(function (error) {});
  };
  return (
    accessSettings() && (
      <Page
        title="Templates"
        primaryAction={
          <Button variant="primary" onClick={handleAddTemplate}>
            Add Template
          </Button>
        }
      >
        {loadingMarkup}
        <Card padding="0">
          <Tabs
            tabs={tabs}
            selected={selected}
            onSelect={handleTabChange}
            fitted
          >
            <Filters
              queryValue={queryValue}
              filters={filters}
              appliedFilters={appliedFilters}
              onQueryChange={handleFiltersQueryChange}
              onQueryClear={handleQueryValueRemove}
              onClearAll={handleFiltersClearAll}
            />
            <DataTable
              columnContentTypes={["text", "text", "text", "text"]}
              headings={[
                <Text variant="bodyMd" as="p" fontWeight="medium">
                  Image
                </Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium">
                  Name
                </Text>,
                // <Text variant="bodyMd" as="p" fontWeight="medium">
                //   Code
                // </Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              ]}
              rows={items}
              verticalAlign="middle"
              increasedTableDensity
            />
            {emtyState}
            {totalPages >= 2 && (
              <div
                style={{
                  paddingTop: "10px",
                  textAlign: "center",
                  paddingBottom: "10px",
                }}
              >
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handleChangePage}
                  size="large"
                />
              </div>
            )}

            <Modal
              open={activeDelete}
              onClose={handleChangeModalDelete}
              title="Delete Template"
              primaryAction={{
                content: "Yes",
                onAction: handleYesDelete,
                loading: isSaving,
              }}
              secondaryActions={[
                {
                  content: "No",
                  loading: isSaving,
                  onAction: handleChangeModalDelete,
                },
              ]}
            >
              <Modal.Section>
                <TextContainer>
                  <p>Are you sure you want to delete this template?</p>
                </TextContainer>
              </Modal.Section>
            </Modal>

            <Modal
              open={activeAddEdit}
              onClose={handleChangeModalAddEdit}
              title={`${
                addEditState.current === "add-template" ? "Add" : "Edit"
              } Template`}
              primaryAction={{
                content: "Submit",
                onAction: handleSubmitAddEdit,
                loading: isSaving,
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  loading: isSaving,
                  onAction: handleChangeModalAddEdit,
                },
              ]}
            >
              <Modal.Section>
                <FormLayout>
                  <TextField
                    label="Name"
                    value={item.name}
                    onChange={handleChangeTemplateName}
                    error={templateNameError}
                    disabled={addEditState.current === "edit-template"}
                  />
                  <TextField
                    label="Description"
                    value={item.description}
                    onChange={handleChangeTemplateDescription}
                  />
                  <Text>Image</Text>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div style={{ float: "left" }}>
                      <Thumbnail
                        size="large"
                        source={item.image ? item.image : ""}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginLeft: "10px",
                      }}
                    >
                      <DropZone
                        accept=".png,.jpeg,.jpg,.svg,.json"
                        //   type="file"
                        allowMultiple={false}
                        onDrop={handleDropZoneDrop}
                        onDropAccepted={sendImage}
                      >
                        {uploadedFile}
                        {fileUpload}
                      </DropZone>
                    </div>
                  </div>
                </FormLayout>
              </Modal.Section>
            </Modal>
            {toastMarkup}
          </Tabs>
        </Card>
        {isImageUploading ? <LoadingScreen /> : null}
      </Page>
    )
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      // case "productType":
      //   return value.join(", ");
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Templates;
